"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _ModuleAnswer_instances, _ModuleAnswer_module, _ModuleAnswer_motives, _ModuleAnswer_score, _ModuleAnswer_comment, _ModuleAnswer_errors, _ModuleAnswer_dirty, _ModuleAnswer_store_key, _ModuleAnswer_preventDirty, _ModuleAnswer_visited, _ModuleAnswer_disabled, _ModuleAnswer_src, _ModuleAnswer_media, _ModuleAnswer_onChange;
Object.defineProperty(exports, "__esModule", { value: true });
const EventEmitter_1 = __importDefault(require("./EventEmitter"));
const hidash_1 = require("./utils/hidash");
const { get, isEqual, reject } = require('lodash');
class ModuleAnswer extends EventEmitter_1.default {
    constructor(module) {
        super();
        _ModuleAnswer_instances.add(this);
        _ModuleAnswer_module.set(this, void 0);
        _ModuleAnswer_motives.set(this, []);
        _ModuleAnswer_score.set(this, void 0);
        _ModuleAnswer_comment.set(this, '');
        _ModuleAnswer_errors.set(this, []);
        _ModuleAnswer_dirty.set(this, false);
        _ModuleAnswer_store_key.set(this, undefined);
        _ModuleAnswer_preventDirty.set(this, false);
        _ModuleAnswer_visited.set(this, false);
        _ModuleAnswer_disabled.set(this, false);
        _ModuleAnswer_src.set(this, undefined);
        _ModuleAnswer_media.set(this, {
            progress: 0,
        });
        __classPrivateFieldSet(this, _ModuleAnswer_module, module, "f");
        this.on('change', () => __classPrivateFieldGet(this, _ModuleAnswer_instances, "m", _ModuleAnswer_onChange).call(this));
        this.on(['score', 'comment', 'motives', 'store_key', 'media:progress', 'src'], () => this.emit('change', this));
        __classPrivateFieldGet(this, _ModuleAnswer_instances, "m", _ModuleAnswer_onChange).call(this);
    }
    get disabled() {
        return __classPrivateFieldGet(this, _ModuleAnswer_disabled, "f");
    }
    get index() {
        return __classPrivateFieldGet(this, _ModuleAnswer_module, "f").index;
    }
    get isValid() {
        var _a;
        return ((_a = __classPrivateFieldGet(this, _ModuleAnswer_errors, "f")) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }
    get dirty() {
        return __classPrivateFieldGet(this, _ModuleAnswer_dirty, "f");
    }
    get mediaWasPlayed() {
        return __classPrivateFieldGet(this, _ModuleAnswer_media, "f").progress === 100;
    }
    set visited(value) {
        __classPrivateFieldSet(this, _ModuleAnswer_visited, value, "f");
    }
    setMediaProgress(value) {
        if (isEqual(__classPrivateFieldGet(this, _ModuleAnswer_media, "f").progress, value))
            return;
        __classPrivateFieldGet(this, _ModuleAnswer_media, "f").progress = value;
        this.emit('media:progress', __classPrivateFieldGet(this, _ModuleAnswer_media, "f").progress);
    }
    get visited() {
        return __classPrivateFieldGet(this, _ModuleAnswer_visited, "f");
    }
    get score() {
        return __classPrivateFieldGet(this, _ModuleAnswer_score, "f");
    }
    get comment() {
        return __classPrivateFieldGet(this, _ModuleAnswer_comment, "f");
    }
    get motives() {
        return __classPrivateFieldGet(this, _ModuleAnswer_motives, "f");
    }
    get store_key() {
        return __classPrivateFieldGet(this, _ModuleAnswer_store_key, "f");
    }
    get errors() {
        return __classPrivateFieldGet(this, _ModuleAnswer_errors, "f");
    }
    get src() {
        return __classPrivateFieldGet(this, _ModuleAnswer_src, "f");
    }
    setSrc(value) {
        if (isEqual(__classPrivateFieldGet(this, _ModuleAnswer_src, "f"), value))
            return;
        __classPrivateFieldSet(this, _ModuleAnswer_src, value, "f");
        this.emit('src', __classPrivateFieldGet(this, _ModuleAnswer_src, "f"));
    }
    setScore(value) {
        if (isEqual(__classPrivateFieldGet(this, _ModuleAnswer_score, "f"), value))
            return;
        __classPrivateFieldSet(this, _ModuleAnswer_score, value, "f");
        this.emit('score', __classPrivateFieldGet(this, _ModuleAnswer_score, "f"));
    }
    setScoreByValue(value) {
        if (typeof value !== 'number')
            return;
        const score = __classPrivateFieldGet(this, _ModuleAnswer_module, "f").getScoreFromValue(value);
        this.setScore(score);
    }
    setComment(value) {
        if (isEqual(__classPrivateFieldGet(this, _ModuleAnswer_score, "f"), value))
            return;
        __classPrivateFieldSet(this, _ModuleAnswer_comment, value, "f");
        this.emit('comment', __classPrivateFieldGet(this, _ModuleAnswer_comment, "f"));
    }
    setStoreKey(value) {
        if (isEqual(__classPrivateFieldGet(this, _ModuleAnswer_store_key, "f"), value))
            return;
        __classPrivateFieldSet(this, _ModuleAnswer_store_key, value, "f");
        this.emit('store_key', __classPrivateFieldGet(this, _ModuleAnswer_store_key, "f"));
    }
    setMotives(value, options = {}) {
        var _a;
        const filtered = reject(value, [undefined, null]);
        __classPrivateFieldSet(this, _ModuleAnswer_preventDirty, (_a = options === null || options === void 0 ? void 0 : options.preventDirty) !== null && _a !== void 0 ? _a : false, "f");
        if (isEqual(__classPrivateFieldGet(this, _ModuleAnswer_motives, "f"), filtered))
            return;
        __classPrivateFieldSet(this, _ModuleAnswer_motives, filtered, "f");
        this.emit('motives', __classPrivateFieldGet(this, _ModuleAnswer_motives, "f"));
    }
    get module() {
        return __classPrivateFieldGet(this, _ModuleAnswer_module, "f");
    }
    get answer() {
        return this;
    }
    updateMotive(payload) {
        const motives = [
            ...__classPrivateFieldGet(this, _ModuleAnswer_motives, "f"),
        ];
        const motiveIndex = (motives || []).findIndex((find) => find.id === payload.id);
        if (motiveIndex === -1) {
            motives.push(payload);
        }
        else {
            motives[motiveIndex] = Object.assign(Object.assign({}, __classPrivateFieldGet(this, _ModuleAnswer_motives, "f")[motiveIndex]), payload);
        }
        const sliced = motives.slice(-__classPrivateFieldGet(this, _ModuleAnswer_module, "f").metadata.settings.maxMotivos);
        this.setMotives(sliced);
    }
    //@ts-ignore
    toggleMotive(payload) {
        const motiveIndex = (__classPrivateFieldGet(this, _ModuleAnswer_motives, "f") || []).findIndex((find) => find.id === payload.id);
        const motives = (() => {
            if (motiveIndex === -1) {
                return [
                    ...__classPrivateFieldGet(this, _ModuleAnswer_motives, "f"),
                    payload,
                ];
            }
            else {
                return __classPrivateFieldGet(this, _ModuleAnswer_motives, "f").filter((motive) => motive.id === payload.id);
            }
        })();
        const sliced = motives.slice(-__classPrivateFieldGet(this, _ModuleAnswer_module, "f").metadata.settings.maxMotivos);
        this.setMotives(sliced);
    }
    toPayload() {
        const payload = {
            id: __classPrivateFieldGet(this, _ModuleAnswer_module, "f").id,
            score: __classPrivateFieldGet(this, _ModuleAnswer_score, "f"),
            comment: __classPrivateFieldGet(this, _ModuleAnswer_comment, "f"),
            motives: __classPrivateFieldGet(this, _ModuleAnswer_motives, "f"),
        };
        return (0, hidash_1.omitByDeep)(payload, (value) => value === undefined);
    }
}
exports.default = ModuleAnswer;
_ModuleAnswer_module = new WeakMap(), _ModuleAnswer_motives = new WeakMap(), _ModuleAnswer_score = new WeakMap(), _ModuleAnswer_comment = new WeakMap(), _ModuleAnswer_errors = new WeakMap(), _ModuleAnswer_dirty = new WeakMap(), _ModuleAnswer_store_key = new WeakMap(), _ModuleAnswer_preventDirty = new WeakMap(), _ModuleAnswer_visited = new WeakMap(), _ModuleAnswer_disabled = new WeakMap(), _ModuleAnswer_src = new WeakMap(), _ModuleAnswer_media = new WeakMap(), _ModuleAnswer_instances = new WeakSet(), _ModuleAnswer_onChange = function _ModuleAnswer_onChange() {
    const media = get(__classPrivateFieldGet(this, _ModuleAnswer_module, "f").metadata.settings, "media");
    const showQuestionAfterVideo = media ? get(media, "showQuestionAfterVideo", true) : false;
    if (!__classPrivateFieldGet(this, _ModuleAnswer_preventDirty, "f")) {
        __classPrivateFieldSet(this, _ModuleAnswer_dirty, true, "f");
    }
    __classPrivateFieldSet(this, _ModuleAnswer_preventDirty, false, "f");
    __classPrivateFieldSet(this, _ModuleAnswer_errors, __classPrivateFieldGet(this, _ModuleAnswer_module, "f").getErrors({ answer: this }), "f");
    __classPrivateFieldSet(this, _ModuleAnswer_disabled, (() => {
        if (showQuestionAfterVideo)
            return !this.mediaWasPlayed;
        return false;
    })(), "f");
};
